import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { GolfAuthLoadingScreen } from '@golfauth/ui';
import { useAuthStore } from '../../store/authStore';
import { supabase } from '../../lib/supabase';

interface GolferProtectedRouteProps {
  children: React.ReactNode;
}

export default function GolferProtectedRoute({ children }: GolferProtectedRouteProps) {
  const { customer, isInitialized } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    if (!isInitialized || customer) return;
    void supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session?.user) return;
      console.error('[GolferProtectedRoute] authenticated user has no customer row; redirecting to login', {
        authUid: session.user.id,
        email: session.user.email,
        path: location.pathname,
      });
    });
  }, [isInitialized, customer, location.pathname]);

  // Show loading spinner while auth is initializing
  if (!isInitialized) {
    return <GolfAuthLoadingScreen />;
  }

  // Redirect to customer login if not authenticated, preserving the intended destination
  if (!customer) {
    return <Navigate to="/customer/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
